<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section">
<h1>1</h1>
<p>July heat hits me as I come from my messianic meeting house. An elderly woman, leaning against my car, straightens up. I know her from media coverage; Mary Ford.</p>
<p>“I know this is your Sabbath Mr Eigerman,” she says, “but consider me a sheep that has fallen into a deep ditch and needs help to get out. You know who I am?”</p>
<p>“I know who you are Mrs Ford.”</p>
<p>“Inspector Black said to see you. Told me you came here Saturdays.”</p>
<p>“Couldn’t wait until tomorrow.”</p>
<p>“Tomorrow’s Sunday.”</p>
<p>“Monday, then.”</p>
<p>“Felt the need to come today. You’ll be busy Monday.”</p>
<p>“I will?”</p>
<p>“Finding my son, Steven.”</p>
<p>“If the police can’t find Steven, what makes you think I can?”</p>
<p>“Police never tried. I’ve given up hope that Steven’s still alive, but I want to know what happened. I want you to find his remains, and who killed him. I want to see them face to face.”</p>
<p>“You want revenge.”</p>
<p>“I want them to know I’ve forgiven them.”</p>
<p>“To forgive is good.”</p>
<p>“Steven needs a Christian burial. You goin’ to help me or not?”</p>
<p>“How’d you get here?”</p>
<p>“Taxi.”</p>
<p>“I’ll take you home. Get in.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?05489c46